import React from 'react';

const BaseSkeleton = ({ 
  className = '', 
  width = 'w-full', 
  height = 'h-4', 
  rounded = 'rounded'
}) => {
  return (
    <div className={`relative ${width} ${height} ${rounded} bg-gray-200 overflow-hidden ${className}`}>
      <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-gray-50/50 to-transparent"></div>
    </div>
  );
};

export const ShimmerSkeleton = BaseSkeleton; 
export default BaseSkeleton;